export const LANDING = '/';
export const MOOD_CATEGORY_SELECTOR = '/mood-category-selector';
export const MOOD_USER = '/mood-user';
export const MOOD_RESULTS = '/mood-results';
export const MOOD_SELECTED_LIST = '/mood-selected-list';

